import React from "react";
import { ShieldCheck, FileDown, Signature } from "lucide-react";

const Row = ({ label, children }) => (
  <div>
    <div className="text-xs uppercase tracking-widest text-slate-500 mb-1">{label}</div>
    <div>{children}</div>
  </div>
);

export const CaseDossier = ({ caseData, docs, onAssign, onSign, caseId }) => {
  const c = caseData;
  const d = c.dossier;
  const backendUrl = process.env.REACT_APP_BACKEND_URL;

  return (
    <section className="bg-white border border-slate-200 rounded-xl p-6">
      <div className="flex items-center justify-between mb-4">
        <h2 className="font-display font-bold text-xl text-[#0B2B62]">Dossiê Inteligente RAF (DIR)</h2>
        <div className="flex items-center gap-2">
          {d && (
            <a
              data-testid="download-dir-pdf"
              href={`${backendUrl}/api/cases/${caseId}/dossier.pdf`}
              target="_blank" rel="noreferrer"
              className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-md border border-slate-200 text-sm text-slate-700 hover:bg-slate-50 transition-colors"
            >
              <FileDown className="w-4 h-4" /> PDF
            </a>
          )}
          <span className="text-xs text-slate-500 inline-flex items-center gap-1"><ShieldCheck className="w-3 h-3" /> Gerado por IA</span>
        </div>
      </div>
      {!d ? <p className="text-sm text-slate-500">Triagem não concluída ainda.</p> : (
        <div className="space-y-4 text-sm">
          <div className={`p-3 rounded-md border-l-4 border-risk-${d.risk_level} bg-slate-50`}>
            <div className="text-xs uppercase tracking-widest text-slate-500">Justificativa</div>
            <p className="text-slate-700 mt-1">{d.risk_justification}</p>
          </div>
          <Row label="Resumo clínico"><p className="text-slate-700 whitespace-pre-line">{d.clinical_summary}</p></Row>
          <Row label="Perfil"><p className="text-slate-700">{d.dependency_profile}</p></Row>
          <Row label="Família"><p className="text-slate-700">{d.family_situation}</p></Row>
          <Row label="Modalidade sugerida"><p className="text-slate-700 capitalize">{d.recommended_modality}</p></Row>
          <Row label="Ações recomendadas">
            <ul className="space-y-1">{(d.recommended_actions || []).map((a, i) => <li key={`${a}-${i}`} className="text-slate-700">• {a}</li>)}</ul>
          </Row>
          {docs.length > 0 && (
            <Row label="Documentos anexados">
              <ul className="space-y-1">
                {docs.map((doc) => (
                  <li key={doc.id}>
                    <a href={`${backendUrl}/api/documents/${doc.id}/download`}
                       target="_blank" rel="noreferrer" className="text-[#0B2B62] hover:underline">📎 {doc.original_filename}</a>
                  </li>
                ))}
              </ul>
            </Row>
          )}
        </div>
      )}
      {!c.consultant_id && (
        <button data-testid="assign-btn" onClick={onAssign}
          className="mt-6 w-full py-2.5 bg-[#0B2B62] text-white rounded-md font-semibold hover:bg-slate-800 transition-colors">
          Assumir este caso
        </button>
      )}
      {d && !c.dossier_signature && c.consultant_id && (
        <button data-testid="sign-btn" onClick={onSign}
          className="mt-4 w-full py-2.5 border border-green-600 text-green-700 rounded-md font-semibold hover:bg-green-50 transition-colors inline-flex items-center justify-center gap-2">
          <Signature className="w-4 h-4" /> Assinar dossiê digitalmente
        </button>
      )}
      {c.dossier_signature && (
        <div className="mt-4 p-3 rounded-md border border-green-200 bg-green-50 text-xs" data-testid="signature-block">
          <div className="font-semibold text-green-700 flex items-center gap-1.5">
            <ShieldCheck className="w-3.5 h-3.5" /> Assinado por {c.dossier_signature.consultor_name}
          </div>
          <div className="text-slate-600 mt-1">{new Date(c.dossier_signature.signed_at).toLocaleString("pt-BR")}</div>
          <div className="text-slate-500 font-mono text-[10px] break-all mt-1">SHA-256: {c.dossier_signature.hash}</div>
        </div>
      )}
    </section>
  );
};
